import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-addresslog',
  templateUrl: './addresslog.component.html',
  styleUrls: ['./addresslog.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class AddresslogComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public userlist: any = [];
  public hide: boolean = true;
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  username;
 userId;
 mobileNumber;
  constructor(
    private userService: UserService,
   private activeroute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.userId = this.activeroute.snapshot.params.id;
  }

  loadUserAddressLog(event: LazyLoadEvent) {
    var query = this.userId;
    this.userService.getUserDetails(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        this.username = data['fullName'];
        this.userlist = data.addressLog;
        this.totalRecords = data['count'];
        this.mobileNumber = data['mobileNumber']
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  addColumns() {
    this.hide = false;

  }

  //use to remove columns
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
